export default function() {
  return {
    items: [],
    pagination: [],
    item: {}
  }
}